import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import { mapState } from 'vuex'
import App from '@/App'
import router from '@/router'
import store from '@/store'
//  logging いらない場合は削除
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import VueI18n from 'vue-i18n'
import VueLocalStorage from 'vue-localstorage'
import '@/assets/scss/common.scss'
import Vuetify from 'vuetify/lib'
import VuetifyJa from 'vuetify/src/locale/ja'
// import colors from 'vuetify/es5/util/colors'

import 'vuetify/src/stylus/app.styl'
import VeeValidate, { Validator } from 'vee-validate'
import VueAnalytics from 'vue-analytics'

// global
import Constants from '@/utils/Constants'
import ApiManager from '@/utils/ApiManager'
import redirectErrorPage from './utils/redirectErrorPage'
//  mixins
import Loading from '@/utils/Loading'
import Alert from '@/utils/Alert'
import Dialog from '@/utils/Dialog'

import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false

Vue.use(VueLazyload, {
  lazyComponent: true
})
//  logging いらない場合は削除
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://2ad8427261c7484e9f2ce1c3cf84283f@sentry.io/1781384',
    ignoreErrors: [/Request failed with status code \d\d\d/],
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true
      })
    ]
  })
  // --------------------------------------
  //  gaの設定
  Vue.use(VueAnalytics, {
    id: 'UA-150202588-1',
    router
  })
}

// --------------------------------------
// localstorage
// データ保存
// this.$localStorage.set(key,value)
// データ削除
// this.$localStorage.remove(key)
// データ取得
// this.$localStorage.get(key)
Vue.use(VueLocalStorage)

// --------------------------------------
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja',
  fallbackLocale: 'ja',
  messages: {
    ja: require('@/utils/lang/ja.json')
  }
})

// --------------------------------------
Vue.use(VeeValidate,
  {
    i18n,
    i18nRootKey: 'validations',
    dictionary: {
      ja: require('vee-validate/dist/locale/ja')
    }
  }
)

VeeValidate.Validator.extend('password_strength', {
  getMessage: field => `${field}は英大文字、英小文字、数字、記号（-_）の内3種類以上で組み合わせてください。`,
  validate: value => {
    if (!/^[A-Za-z0-9\-_]+$/.test(value)) {
      return false
    }
    const hasUpperCase = /[A-Z]/.test(value)
    const hasLowerCase = /[a-z]/.test(value)
    const hasNumbers = /\d/.test(value)
    const hasSpecialChar = /[-_]/.test(value)

    const typesCount = [hasUpperCase, hasLowerCase, hasNumbers, hasSpecialChar].filter(Boolean).length
    return typesCount >= 3
  }
})

VeeValidate.Validator.extend('password_strength_br', {
  getMessage: field => `${field}は英大文字、英小文字、数字、記号（-_）の内<br>3種類以上で組み合わせてください。`,
  validate: value => {
    if (!/^[A-Za-z0-9\-_]+$/.test(value)) {
      return false
    }
    const hasUpperCase = /[A-Z]/.test(value)
    const hasLowerCase = /[a-z]/.test(value)
    const hasNumbers = /\d/.test(value)
    const hasSpecialChar = /[-_]/.test(value)

    const typesCount = [hasUpperCase, hasLowerCase, hasNumbers, hasSpecialChar].filter(Boolean).length
    return typesCount >= 3
  }
})

Validator.localize('ja', {
  messages: {
    required: field => `${field}を正しく入力して下さい。`
  }
})

// --------------------------------------
Vue.use(Vuetify, {
  lang: {
    locales: { VuetifyJa },
    current: 'VuetifyJa'
  },
  //  https://vuetifyjs.com/en/framework/breakpoints
  breakpoint: {
    thresholds: {
      xs: 0,
      sm: 0,
      md: 0,
      lg: 1200
    }
  },
  //  https://vuetifyjs.com/en/framework/colors
  theme: {
    primary: '#31b9b7',
    secondary: '#7fc4fd',
    accent: '#FF4081',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  //  https://vuetifyjs.com/en/framework/icons
  iconfont: 'mdi',
  icons: {
    'header-default': 'mdi-solid'
  }
})

// $vuetify.dataIterator.noResultsText
// --------------------------------------
// redirectErrorPage
// ex.: this.$redirectErrorPage('message', statusCode)
Object.defineProperty(Vue.prototype, '$redirectErrorPage', { value: redirectErrorPage })

//  global method
Vue.mixin(Loading)
Vue.mixin(Dialog)
Vue.mixin(Alert)

Constants['_store'] = store
Constants['getToken'] = () => {
  return Constants._store.getters['account/getToken']
}
Constants['getUser'] = (key) => {
  return Constants._store.getters['account/getUserByKey'](key)
}
Constants['getContract'] = (key) => {
  return Constants._store.getters['account/getContractByKey'](key)
}
Constants['getPosDate'] = () => {
  return Constants._store.getters['account/getPosDate']
}
Constants['getSite'] = (key) => {
  return Constants._store.getters['account/getSiteByKey'](key)
}
Constants['getFirebase'] = (key) => {
  return Constants._store.getters['account/getFirebaseByKey'](key)
}
Constants['getPageName'] = (type) => {
  return Constants._store.getters['account/getPageNameByType'](type)
}
Constants['getCategoryRankName'] = () => {
  return Constants._store.getters['account/getCategoryRankName']()
}
Constants['getShopCategoryRankName'] = () => {
  return Constants._store.getters['account/getShopCategoryRankName']()
}
Constants['getAnalyzeTarget'] = (code) => {
  return Constants._store.getters['account/getAnalyzeTargetByCode'](code)
}

store.dispatch('condition/initConfig')

if (process.env.NODE_ENV === 'production') {
  Constants['apiEndPoint'] = window.location.protocol + '//' + window.location.host + '/api'
} else {
  Constants['apiEndPoint'] = process.env.API_ENDPOINT
}
console.log('apiEndPoint', Constants['apiEndPoint'])

window.Constants = Constants

const app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  computed: {
    ...mapState('account', {
      site: state => state.site
    }),
    ...mapState('meta', {
      browserTitle: state => state.title
    })
  },
  methods: {
    setSiteData () {
      const logoFlag = Constants.getSite('logo_flag')
      // フラグの判定が行えなかった場合は何もしない
      if (!logoFlag) {
        return
      }
      // faviconの変更
      const link = document.querySelector("link[rel*='icon']")
      link.href = (logoFlag === '0' ? Constants.getSite('favicon_path') : Constants.DefaultFaviconPath)
      // ブラウザタイトルの更新
      store.dispatch('meta/set', { title: this.browserTitle })
    }
  },
  watch: {
    site () {
      this.setSiteData()
    }
  }
})
app.$mount('#app')

window.ApiManager = ApiManager
ApiManager.init(app)

router.beforeEach((to, from, next) => {
  store.dispatch('loading/loadingPageReset')
  store.dispatch('loading/loadingScreenReset')
  store.commit('alertscreen/resetAlert')

  if (to.matched.some(record => record.meta.requiredAuth)) {
    let isAuth = !!Vue.localStorage.get('token')
    if (isAuth) {
      next()
    } else {
      next({
        path: 'login'
      })
    }
    // Auth.currentAuthenticatedUser()
    //   .then(() => {
    //     next()
    //   })
    //   .catch(error => {
    //     console.error(error)
    //     next({
    //       path: 'pageLogin',
    //       query: { redirect: to.fullPath }
    //     })
    //   })
  }
  next()
})
